const IntegritasLogoS = () => {
  return (
    <svg
      width="100"
      height="32"
      viewBox="0 0 137 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.94424 0V4.32521H0V0H4.94424ZM4.94424 6.4865V24.7158H0V6.4865H4.94424Z"
        fill="white"
      />
      <path
        d="M24.7183 12.9761V24.7164H19.774V14.0568C19.774 12.0162 18.1058 10.348 16.0652 10.348C14.0245 10.348 12.3564 12.0162 12.3564 14.0568V24.7164H7.41211V6.48703H12.2016L12.3564 8.61946C13.6232 7.04309 15.5695 6.02539 17.7622 6.02539C21.5944 6.02539 24.7157 9.14667 24.7157 12.9761H24.7183Z"
        fill="white"
      />
      <path
        d="M32.1347 10.8147V19.9293C32.1347 21.288 33.2468 22.4001 34.6055 22.4001V24.7162C33.9262 24.9627 33.1839 25.1175 32.4127 25.1175C29.538 25.1175 27.1904 22.8932 27.1904 20.1129V2.16162H32.1347V6.48683H34.6055V10.812H32.1347V10.8147Z"
        fill="white"
      />
      <path
        d="M40.1061 16.8392C40.2608 19.2812 41.9605 20.9179 44.1847 20.9179C45.9447 20.9179 47.2116 20.0523 47.6444 18.6936H52.7722C51.8149 22.6175 48.5388 25.1198 44.1821 25.1198C38.7762 25.1198 35.0674 21.3192 35.0674 15.6038C35.0674 9.88847 38.8051 6.0249 44.0274 6.0249C49.2496 6.0249 52.9873 10.0118 52.9873 15.6038C52.9873 16.0366 52.9559 16.4379 52.927 16.8392H40.1034H40.1061ZM40.3841 13.1304H47.6759C47.306 11.3993 45.8215 10.2268 44.03 10.2268C42.2385 10.2268 40.7854 11.4622 40.3841 13.1304Z"
        fill="white"
      />
      <path
        d="M79.7109 9.23847C80.9463 7.32374 83.1102 6.02539 85.581 6.02539V10.6601C82.3364 10.6601 79.7109 12.7296 79.7109 15.2948V24.719H74.7666V6.48965H79.7109V9.23847Z"
        fill="white"
      />
      <path
        d="M91.7607 0V4.32521H86.8164V0H91.7607ZM91.7607 6.4865V24.7158H86.8164V6.4865H91.7607Z"
        fill="white"
      />
      <path
        d="M99.1747 10.8144V19.9291C99.1747 21.2878 100.287 22.3999 101.646 22.3999V24.7159C100.966 24.9625 100.224 25.1172 99.4527 25.1172C96.578 25.1172 94.2305 22.893 94.2305 20.1127V2.16138H99.1747V6.48658H101.646V10.8118H99.1747V10.8144Z"
        fill="white"
      />
      <path
        d="M118.544 11.4938V24.7186H113.754L113.6 23.1737C112.548 24.3776 111.158 25.1199 108.75 25.1199C104.889 25.1199 102.261 23.1422 102.261 19.4045C102.261 15.6668 105.288 14.1219 110.573 13.1934C112.86 12.7921 113.786 12.4223 113.786 11.5252C113.786 10.5364 112.396 10.0118 110.911 10.0118C109.427 10.0118 108.068 10.5993 108.068 11.8977H103.124C103.124 8.00527 106.059 6.02759 110.88 6.02759C115.701 6.02759 118.541 7.91347 118.541 11.4964L118.544 11.4938ZM113.6 18.476V16.2832C112.703 16.5613 111.654 16.779 110.573 16.9626C108.039 17.4268 107.019 17.9514 107.019 19.0321C107.019 20.1127 108.223 20.855 109.922 20.855C111.622 20.855 113.6 19.8347 113.6 18.476Z"
        fill="white"
      />
      <path
        d="M136.188 19.2476C136.188 22.8619 132.975 25.1177 128.185 25.1177C123.396 25.1177 120.091 23.077 120.091 18.6915H125.035C125.035 20.4226 126.365 21.2252 128.28 21.2252C130.194 21.2252 131.432 20.3597 131.432 19.3105C131.432 18.2613 130.289 17.5794 128.188 17.2095C123.183 16.3125 120.587 14.6758 120.587 11.4942C120.587 8.31258 123.739 6.02539 128.125 6.02539C132.51 6.02539 135.758 8.00308 135.758 11.8955H130.813C130.813 10.5971 129.578 9.98076 128.033 9.98076C126.488 9.98076 125.345 10.6286 125.345 11.4339C125.345 12.2391 126.425 12.7637 128.188 13.0706C133.255 13.9676 136.19 15.7276 136.19 19.2502L136.188 19.2476Z"
        fill="white"
      />
      <path
        d="M72.6048 15.3707C72.6048 15.3445 72.6048 15.3182 72.6022 15.292V6.48947H68.0934V7.38651C66.6822 6.52881 65.0298 6.02783 63.2567 6.02783C58.0947 6.02783 53.9111 10.2114 53.9111 15.3733C53.9111 20.5352 58.0947 24.7188 63.2567 24.7188C64.8488 24.7188 66.3465 24.3175 67.6606 23.6172V24.029C67.6606 26.0696 66.0921 27.7378 63.2567 27.7378C61.4468 27.7378 60.5367 27.187 59.8547 26.3476L55.4534 28.5089C56.9852 30.602 59.5767 32 63.2436 32C68.8226 32 72.6022 28.6007 72.6022 24.3673V15.3891C72.6022 15.3891 72.6022 15.3786 72.6022 15.3733L72.6048 15.3707ZM63.2593 20.4828C60.8278 20.4828 58.8554 18.193 58.8554 15.3707C58.8554 12.5484 60.8278 10.2586 63.2593 10.2586C65.6908 10.2586 67.6632 12.5484 67.6632 15.3707C67.6632 18.193 65.6908 20.4828 63.2593 20.4828Z"
        fill="white"
      />
    </svg>
  );
};
export default IntegritasLogoS;
